export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ18.bf8a60d0.mp3";